import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function SubMenuItemManage ( props ) {

    return <BasicCrudScreenType id="SubMenuItems" table="SubMenuItems" view="VwSubMenuItems" />;

}

export default SubMenuItemManage;
